// extracted by css-extract-rspack-plugin
export default {"trigger":"trigger-JcdYgG","item":"item-b8zECe"};